module.exports = __webpack_public_path__ + "media/src/assets/Images/Download-01ee61e27a9538b1ea95bfc33ba50ccb.svg";